import styles from 'styled-components';

const StyledHeading2 = styles.h1`
  font-size: 24px;
  font-weight: bold;
  color: #ffffff;
  padding: 0px;
  margin: 20px 0px;
  text-align: ${({ textalign }) => (textalign ? textalign : 'left')};
`;

const Heading2 = ({ children, textAlign, ...rest }) => (
  <StyledHeading2 textalign={textAlign} {...rest}>
    {children}
  </StyledHeading2>
);

export default Heading2;
